$(function () {
    $('*[data-multiSelect]').each(function () {
        new MultiSelect($(this));
    })
})